<h1 mat-dialog-title>Terms of Usage</h1>
<mat-dialog-content>
  <div [innerHtml]="terms"></div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true" *ngIf="!showButton">
    Close
  </button>
  <button
    mat-raised-button
    [color]="'primary'"
    [mat-dialog-close]="true"
    *ngIf="showButton"
  >
    Agreed
  </button>
</mat-dialog-actions>
